<div
  role="group"
  class="select-button-container"
  [class.select-button-container--segment]="variant === 'segment'"
>
  <ng-container *ngFor="let option of options; let i = index">
    <button
      class="select-button"
      [class.select-button--highlight]="isSelected(option)"
      [class.select-button--full-size]="readonly"
      (click)="handleOptionSelect($event, option, i)"
    >
      <icon
        *ngIf="option.icon"
        [set]="option.iconSet || 'lucide'"
        [name]="option.icon"
        [size]="20"
      />
      <span>{{ option.label | translate }}</span>
    </button>
  </ng-container>
</div>
